import { EAccessLevel } from "../../shared/oversight-core/enums/access-level";
import { EOrgUserRole } from "../../shared/oversight-core/enums/org-user-role";

export interface IRoleDefinition {
  role: EOrgUserRole;
  typicalAccess: string;
  typicalSeat: "User" | "Guest";
}

// true = allowed, false = not allowed, text = allowed with a condition.
export type CapabilityValue = boolean | string;

export interface IAccessCapability {
  label: string;
  levels: Record<
    Exclude<EAccessLevel, EAccessLevel.NO_ACCESS>,
    CapabilityValue
  >;
}

// Fixed by the platform: roles and levels are built into its permission checks, so there
// is no API to list or edit them.
export const roleDefinitions: IRoleDefinition[] = [
  {
    role: EOrgUserRole.ROLE_ORG_ADMIN,
    typicalAccess: "Admin",
    typicalSeat: "User",
  },
  {
    role: EOrgUserRole.ROLE_ORG_VIEWER,
    typicalAccess: "View",
    typicalSeat: "User",
  },
  {
    role: EOrgUserRole.ROLE_ORG_OPERATOR,
    typicalAccess: "Operate",
    typicalSeat: "User",
  },
  {
    role: EOrgUserRole.ROLE_ORG_GUEST,
    typicalAccess: "Guest",
    typicalSeat: "Guest",
  },
];

export const accessCapabilities: IAccessCapability[] = [
  {
    label: "See sites, generation and reports",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: true,
      [EAccessLevel.VIEW]: true,
      [EAccessLevel.VIEW_REDACTED]: true,
    },
  },
  {
    label: "See exact values",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: true,
      [EAccessLevel.VIEW]: true,
      [EAccessLevel.VIEW_REDACTED]: "Hidden",
    },
  },
  {
    label: "Control devices, flag customers",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: true,
      [EAccessLevel.VIEW]: false,
      [EAccessLevel.VIEW_REDACTED]: false,
    },
  },
  {
    label: "Manage users and access",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: false,
      [EAccessLevel.VIEW]: false,
      [EAccessLevel.VIEW_REDACTED]: false,
    },
  },
  {
    label: "Edit branches and site placement",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: false,
      [EAccessLevel.VIEW]: false,
      [EAccessLevel.VIEW_REDACTED]: false,
    },
  },
  {
    label: "Can be permanent",
    levels: {
      [EAccessLevel.ADMIN]: true,
      [EAccessLevel.OPERATE]: true,
      [EAccessLevel.VIEW]: true,
      [EAccessLevel.VIEW_REDACTED]: "Must expire",
    },
  },
];
